import {
  type Company,
  CurrentStepEnum,
} from "@boundless/bl-api-client/customer/models"
import { Link, linkOptions } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import { getCurrentStepPath } from "@/lib/utils"

const getButtonText = (company: Company | undefined) => {
  if (!company) return "Start Now"

  if (
    company.currentStep === CurrentStepEnum.lender &&
    company.hasSubmittedApplication
  ) {
    return "Apply to More Lenders"
  }
  return "Continue"
}

export function ContinueButton({ company }: { company: Company | undefined }) {
  const continueTo = company
    ? getCurrentStepPath(
        company.currentStep,
        company.latestUnsubmittedApplicationUuid,
        company.latestSubmittedFundingNeedsUuid,
      )
    : linkOptions({ to: "/company/details" })

  return (
    <Button className="self-start" asChild>
      <Link {...continueTo}>{getButtonText(company)}</Link>
    </Button>
  )
}
